import React, { useState } from 'react';
import './Project.css';
import { useParams } from 'react-router';
import useProjectData from '../../HomePage/ProjectData/useProjectData';
import HomeNavbar from '../../HomePage/HomeNavbar/HomeNavbar';
import { NavHashLink } from 'react-router-hash-link';

const Project = () => {
    const [project,setProject] = useState({});
    const { projectData } = useProjectData();
    const { id } = useParams();
    console.log(projectData)
    const data = projectData.find(proj => proj.id===id)
    console.log(data)
    const {  name, tech,techDetails, features,github,liveSite, photo} = data;
    const [mainImage,setMainImage] = useState(photo.imageOne);
    const setProjectImage = pName =>{
        setMainImage(pName);
    }
    return (
        <div>
            <HomeNavbar></HomeNavbar>
            <div className="project-main-container">
                <div className="project-image-container">
                    <img src={mainImage} alt="" />
                </div>
                <div className="project-all-image-container">
                    <div className="project-all-image-selector-desktop" onClick={()=>setProjectImage(photo.imageOne)}>
                        <img src={photo.imageOne} alt="" />
                    </div>
                    <div className="project-all-image-selector-desktop" onClick={()=>setProjectImage(photo.imageTwo)}>
                        <img src={photo.imageTwo} alt="" />
                    </div>
                    <div className="project-all-image-selector-desktop" onClick={()=>setProjectImage(photo.imageThree)}>
                        <img src={photo.imageThree} alt="" />
                    </div>
                    <div className="project-all-image-selector-mobile" onClick={()=>setProjectImage(photo.imageFour)}>
                        <img src={photo.imageFour} alt="" />
                    </div>
                    <div className="project-all-image-selector-mobile" onClick={()=>setProjectImage(photo.imageFive)}>
                        <img src={photo.imageFive} alt="" />
                    </div>
                    <div className="project-all-image-selector-mobile" onClick={()=>setProjectImage(photo.imageSix)}>
                        <img src={photo.imageSix} alt="" />
                    </div>
                </div>
                <div className="project-name">
                    <h2>{name}</h2>
                </div>
                <div className="project-technology-container">
                    {techDetails.map(tech => <div className="project-technology-single">{tech}</div>)}
                </div>
                <div className="project-external-links">
                    <a href={liveSite} target="_blank" rel="noreferrer" ><button className="primary-btn">Live Site</button></a>
                    <a href={github}  target="_blank" rel="noreferrer" ><button className="primary-btn">Github</button></a>
                    <a href={github}  target="_blank" rel="noreferrer" ><NavHashLink to="/" className="primary-btn">home</NavHashLink></a>
                </div>
                <hr/>
                <div className="projects-features-header"><h3>Features</h3></div>
                <div className="project-feature-main-container">
                    {
                        features.map(feature => <div><h3>{feature}</h3></div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Project;